var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup52(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.469,
    height: 107.332,
    viewBox: "0 0 162.469 107.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-1883.665 -1846.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M3047.319,846.43l-13.146,22.761-13.147,22.566-13.147-22.566-13.146-22.761Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M3047.319,953.762h-52.586L3007.879,931l13.147-22.565L3034.173,931Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M3102.26,852.317l-12.95,22.761-13.147,22.566h-52.391l12.951-22.566,13.147-22.761Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M3102.26,948.464h-52.39L3036.723,925.7l-12.951-22.566h52.391L3089.31,925.7Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M3018.279,897.643h-52.391l-13.146-22.565-12.951-22.762h52.391Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M3018.279,903.137,3005.328,925.7l-13.146,22.762h-52.391l12.951-22.762,13.146-22.565Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup52);
export default __webpack_public_path__ + "static/media/Group 52.7d5c6dea131ebff541c22e782d36a678.svg";
export { ForwardRef as ReactComponent };